import { SpecialDetailLayout, SpecialDetailStatus } from '@iheartjane/menu';
import { useLoaderData } from 'react-router';

import { Breadcrumbs } from '@jane/bloom/components/breadcrumbs/breadcrumbs';
import { BloomGoldCalloutBanner } from '@jane/bloom/components/janeGold/bloomGoldCalloutBanner';
import { MenuHeader } from '@jane/bloom/components/menuHeader/menuHeader';
import { useMemoizedRowInstance } from '@jane/bloom/hooks/dm/useMemoizedRowInstance';
import { BloomFilterProvider } from '@jane/bloom/hooks/filters/provider';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import type { JaneGoldDetailResults } from '@jane/bloom/loaders/routes/janeGoldDetail.server';

import { GoldInfoBox } from './components/goldInfoBox';
import { GoldProductGrid } from './components/goldProductGrid';

import styles from './janeGoldDetailComponent.module.css';

export const JaneGoldDetailRouteComponent = () => {
  const { pinnedStore } = useRootLoaderData();
  const {
    applicablePriceIds,
    availableFilters,
    brandSpecials,
    brandSpecialWithStatus,
    breadcrumbs,
    complianceLanguage,
    currentSpecial,
    customLanguage,
    hasLinkedBank,
    isSegmentedDeal,
    isSignedIn,
    janeGold,
    menuProductImgsAboveTheFold,
    recommendedSortResults,
    searchCriteria,
    sort: { currentSort, sortOptions },
    storeSpecials,
  } = useLoaderData<JaneGoldDetailResults>();

  const rowInstance = useMemoizedRowInstance(recommendedSortResults);

  return (
    <>
      <MenuHeader />
      <main className={styles['janeGoldDetailMain']}>
        <Breadcrumbs
          className={styles['janeGoldDetailBreadcrumbs']}
          breadcrumbs={breadcrumbs}
        />

        <BloomGoldCalloutBanner
          hasLinkedBank={hasLinkedBank}
          isSegmentedDeal={isSegmentedDeal}
          isSignedIn={isSignedIn}
          storeState={pinnedStore.state}
          mb={16}
        />

        <SpecialDetailLayout px={0} isLoading={false}>
          <SpecialDetailLayout.Banner p={8} top="var(--header-height)">
            <SpecialDetailStatus.Sticky
              calloutSubtext={brandSpecialWithStatus.stickyCalloutSubtext}
              calloutText={brandSpecialWithStatus.stickyCallout}
              isGold
              onClick={() => window.scrollTo({ behavior: 'smooth', top: 0 })}
              qualifyingStatus={brandSpecialWithStatus.qualifyingStatus}
              subtext={brandSpecialWithStatus.stickySubtext}
              text={brandSpecialWithStatus.stickyText}
            />
          </SpecialDetailLayout.Banner>

          <SpecialDetailLayout.Summary headerHeight={80}>
            <GoldInfoBox
              brandSpecial={brandSpecialWithStatus}
              complianceLanguage={complianceLanguage}
              currentSpecial={currentSpecial}
            />
          </SpecialDetailLayout.Summary>

          <SpecialDetailLayout.Content>
            <BloomFilterProvider
              availableFilters={availableFilters}
              searchCriteria={searchCriteria}
              shouldShowGold={false}
            >
              <GoldProductGrid
                rowInstance={rowInstance}
                preloadedProductIds={menuProductImgsAboveTheFold.map(
                  ({ id }) => id
                )}
                brandSpecials={brandSpecials}
                customLanguage={customLanguage}
                currentSort={currentSort}
                sortOptions={sortOptions}
                janeGold={janeGold}
                storeSpecials={storeSpecials}
                applicablePriceIds={applicablePriceIds}
              />
            </BloomFilterProvider>
          </SpecialDetailLayout.Content>
        </SpecialDetailLayout>
      </main>
    </>
  );
};
